import Vue from "vue";
import Public from "./app.public.vue";
import Private from "./app.private.vue";
import { router } from "./app.router";
import { i18n } from "./app.culture";
import { legacyComponent } from "./component/legacyform/Legacy.js";
import Hubs from './app.hubs';
import accessTokenManager from './app.accessToken';

new Vue({
    el: "#app",
    i18n,
    router,
    render: h => {
        if (payload.el === "Private") {
            return h(Private);
        } else {
            return h(Public);
        }
    },
    mounted() {
        new Hubs().init();
        new accessTokenManager();
    }
});


Vue.config.productionTip = false;
